// extracted by mini-css-extract-plugin
module.exports = {"footer":"index_footer_ml2Dc","container":"index_container_3o8pY","wrapper":"index_wrapper_1WYPA","copyright":"index_copyright_3THBb","title":"index_title_3e1O0"};